export const createDisplayName = (item) => {
    var _a, _b, _c, _d;
    let dpName = (item === null || item === void 0 ? void 0 : item.dpName) || (item === null || item === void 0 ? void 0 : item.dpNm);
    if ((item === null || item === void 0 ? void 0 : item.dpInsTyp) == "FUT" /* exchangeList.FUTURE */ || ((_a = item === null || item === void 0 ? void 0 : item.asTyp) === null || _a === void 0 ? void 0 : _a.includes("FUT")))
        return dpName + " " + ((_b = item === null || item === void 0 ? void 0 : item.dpExpDt) === null || _b === void 0 ? void 0 : _b.split("'")[0]) + " " + (item === null || item === void 0 ? void 0 : item.dpInsTyp);
    else if ((item === null || item === void 0 ? void 0 : item.dpInsTyp) == "OPT" /* exchangeList.OPTION */ || ((_c = item === null || item === void 0 ? void 0 : item.asTyp) === null || _c === void 0 ? void 0 : _c.includes("OPT"))) {
        return (dpName +
            " " +
            ((_d = item === null || item === void 0 ? void 0 : item.dpExpDt) === null || _d === void 0 ? void 0 : _d.split("'")[0]) +
            " " +
            (item === null || item === void 0 ? void 0 : item.opTyp) +
            " " +
            (item === null || item === void 0 ? void 0 : item.stkPrc));
    }
    else
        return dpName;
};
;
export const findInstrument = (symList) => {
    let symDetail = symList.filter((symDet) => symDet.exc == "NFO" /* excList.NFO */);
    if (symDetail && symDetail[0])
        return symDetail[0].optExpIdx;
    else
        return "";
};
